module.exports = {

  title: {
    prefix: 'Point Blank',
    params: {}
  },

  header: {
    title: 'Point blank',
    auth: 'Вход'
  },

  nav: [
    {
      title: 'Новости',
      name: 'newsHome',
      children: [{
        title: 'Новости',
        name: 'newsHome'
      }, {
        title: 'Новости',
        name: 'newsHome',
        query: {
          type: 'only-news'
        }
      }, {
        title: 'Обзоры',
        name: 'newsHome',
        query: {
          type: 'reviews'
        }
      }, {
        title: 'Интервью',
        name: 'newsHome',
        query: {
          type: 'interviews'
        }
      }]
    },
    {
      title: 'Турниры',
      name: 'tournaments',
      children: [{
        title: 'Все',
        name: 'tournaments'
      }, {
        title: 'Активные',
        name: 'tournaments',
        query: {
          type: 'in_progress'
        }
      }, {
        title: 'Завершенные',
        name: 'tournaments',
        query: {
          type: 'finished'
        }
      }]
    },
    {
      title: 'Команды',
      name: 'teams',
      children: [{
        title: 'Имени',
        name: 'teams',
        query: {
          sort: 'title'
        }
      }, {
        title: 'Играм',
        name: 'teams',
        query: {
          sort: '-total_games'
        }
      }, {
        title: 'Победам',
        name: 'teams',
        query: {
          sort: '-won_games'
        }
      }, {
        title: 'Поражениям',
        name: 'teams',
        query: {
          sort: '-lost_games'
        }
      }, {
        title: 'Очкам',
        name: 'teams',
        query: {
          sort: '-score'
        }
      }, {
        title: 'Свободным местам',
        name: 'teams',
        query: {
          sort: 'member_count'
        }
      }]
    },
    {
      title: 'Игроки',
      name: 'players',
      children: [{
        title: 'Имени',
        name: 'players',
        query: {
          sort: 'nickname'
        }
      }, {
        title: 'Играм',
        name: 'players',
        query: {
          sort: '-total_games'
        }
      }, {
        title: 'Победам',
        name: 'players',
        query: {
          sort: '-won_games'
        }
      }, {
        title: 'Поражениям',
        name: 'players',
        query: {
          sort: '-lost_games'
        }
      }, {
        title: 'Очкам',
        name: 'players',
        query: {
          sort: '-score'
        }
      }, {
        title: 'Без команды',
        name: 'players',
        query: {
          sort: 'has_team'
        }
      }]
    },
    {
      title: 'FAQ',
      name: 'faq'
    },
    {
      title: 'Карта сайта',
      name: 'sitemap',
      bottomOnly: true
    },
    {
      title: 'О проекте',
      href: '/aboutproject',
      bottomOnly: true
    },
    {
      title: 'Отзывы',
      name: 'feedback'
    }
  ],

  form: {
    foo: '',
    bar: ''
  },

  signInForm: {
    nickname: 'admin',
    password: 'qwe123qwe'
  },

  user: null,
  team: null,

  teams: {
    list: [],
    noMore: false
  },

  teamData: {},

  users: {
    list: [],
    noMore: false
  },

  userData: {},

  gameData: {}

};

if (process.env.NODE_ENV !== 'production') {
  module.exports.nav.unshift({
    title: 'Playground',
    name: 'playground'
  });
}



// WEBPACK FOOTER //
// ./src/data.js